import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_30px_rgba(59,130,246,0.1)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-155">
          {/* Subtle background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[50px] pointer-events-none" data-id="element-156"></div>

          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 rounded-full flex items-center justify-center mb-8 shadow-inner" data-id="element-157">
            <span className="text-5xl drop-shadow-[0_0_15px_rgba(59,130,246,0.5)]" data-id="element-158">
              🛡️
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-6 tracking-tight" data-id="element-159">
            RECUPERA TU TIEMPO O TE REEMBOLSAMOS
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-160">
            Estamos tan seguros de la eficacia de{' '}
            <span className="text-text-main font-bold" data-id="element-161">
              MEGAPACK HANDBALL LISTO
            </span>{' '}
            que te damos{' '}
            <span className="text-primary font-bold" data-id="element-162">7 días para probarlo</span>
            . Si no sientes que tu trabajo como entrenador es más fácil y
            fluido, te devolvemos el{' '}
            <span className="text-text-main font-bold" data-id="element-163">100% de tu dinero</span>.{' '}
            <span className="text-text-main font-bold" data-id="element-164">Sin preguntas.</span>
          </p>
        </div>
      </div>
    </section>;
}